import React from "react";

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        // Atualiza o state para que a próxima renderização exiba a UI alternativa
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // Você pode logar o erro em um serviço de relatório aqui
        console.error("ErrorBoundary capturou um erro", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{ padding: "2rem", textAlign: "center" }}>
                    <h1>Algo deu errado.</h1>
                    <p>Tente recarregar a página.</p>
                </div>
            );
        }

        return this.props.children;
    }
}
